import Heropage from "../components/Heropage";
import Skills from "../components/Skills";
import Project from "../components/Project";
import { Experience } from "./Experience";

const Main = () => {
  return (
    <div className="overflow-x-hidden w-full">
      <Heropage />
      <Skills />
      <Project />
      <Experience />
    </div>
  );
};

export default Main;
